import React from 'react';
import PropTypes from 'prop-types';

import {getSellEventUrl} from '@stubhub/sell-url-helper';

class HeaderHacks extends React.Component {
  constructor(props) {
    super(props);
  }

  observer = null;

  componentDidMount() {
    const {eventId} = this.props;
    if (eventId) {
      this.updateHeaderSellUrl(eventId);
      this.changeSellURLViaMutationObserver(eventId);
    }
  }

  componentDidUpdate(prevProps) {
    const {eventId} = this.props;
    const {eventId: prevEventId} = prevProps;
    if (document && eventId !== prevEventId) {
      this.updateHeaderSellUrl(eventId);
      this.changeSellURLViaMutationObserver(eventId);
    }
  }

  updateHeaderSellUrl = (eventId) => {
    // Original Purple Header
    const originalPurpleSellElement = document.querySelector('#sell\\ Tickets > a');

    // Merch Header
    const merchHeaderSellElement = document.querySelector('#sell > button a');
    const merchHeaderDropdownSellTickets = document.querySelector('.option__sell-tickets');
    if (originalPurpleSellElement || (merchHeaderSellElement && merchHeaderDropdownSellTickets)) {
      this.observer && this.observer.disconnect();
      const sellFlowUrl = getSellEventUrl(eventId);
      originalPurpleSellElement && originalPurpleSellElement.setAttribute('href', `/${sellFlowUrl}`);

      merchHeaderSellElement && merchHeaderSellElement.setAttribute('href', `/${sellFlowUrl}`);
      merchHeaderDropdownSellTickets && merchHeaderDropdownSellTickets.setAttribute('href', `/${sellFlowUrl}`);

      return true;
    }

    return false;
  };

  changeSellURLViaMutationObserver = (eventId) => {
    if (document) {
      const target = document.querySelector('header') || document.documentElement;
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if ((mutation.type === 'childList' || mutation.type === 'subtree') && mutation.addedNodes.length) {
            this.updateHeaderSellUrl(eventId);
          }
        });
      });

      this.observer.observe(target, {
        childList: true,
        subtree: true,
      });
    }
  };
  render() {
    return null;
  }
}
HeaderHacks.propTypes = {
  /**
   * Id of event
   */
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default HeaderHacks;
